"use strict";
/*
 * Created on 02 22 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var ExportedOptimizationScenarioConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ExportedOptimizationScenarioConverter, _DataObjectConverter_);

  function ExportedOptimizationScenarioConverter() {
    _classCallCheck(this, ExportedOptimizationScenarioConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedOptimizationScenarioConverter).apply(this, arguments));
  }

  return ExportedOptimizationScenarioConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ExportedOptimizationScenarioConverter = ExportedOptimizationScenarioConverter;